<template>
  <div :class="{ 'content-height': !loaded }">
    <div
      class="row g-0 d-none d-lg-flex"
      v-show="records && records.length > 0"
    >
      <div
        class="col-lg-4 col-wrap"
        v-for="r in records"
        v-cloak
        :key="r.year"
        :style="{
          backgroundImage: `url(//www.animlab.yuntech.edu.tw/upload/2021/record/${r.image})`,
        }"
        style="background-size: cover"
      >
        <div class="year-block">
          <div class="slide-up">
            <div class="year h2-style">{{ r.year }}年度</div>
            <div class="d-flex tags">
              <a
                v-if="r.site_link.length > 0"
                :href="r.site_link"
                class="tag-link"
                target="_blank"
                >計畫網站<img :src="linkArrow" alt=""
              /></a>
              <a
                v-if="r.portfolio_link.length > 0"
                :href="r.portfolio_link"
                class="tag-link"
                target="_blank"
                >學習實錄<img :src="linkArrow" alt=""
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="records-mobile"
      class="d-lg-none"
      v-if="records && records.length > 0"
    >
      <div class="records-wrapper">
        <template v-for="r in records" :key="r.year">
          <div class="d-inline-flex records-unit flex-column">
            <div class="text-start small-text w-100">{{ r.year }}年度</div>
            <div
              class="w-100 main-image"
              :style="{
                backgroundImage: `url(//www.animlab.yuntech.edu.tw/upload/2021/record/${r.image})`,
              }"
            ></div>
            <div class="d-flex tags">
              <a
                v-if="r.site_link.length > 0"
                :href="r.site_link"
                class="tag-link"
                target="_blank"
                >計畫網站<img :src="linkArrow" alt=""
              /></a>
              <a
                v-if="r.portfolio_link.length > 0"
                :href="r.portfolio_link"
                class="tag-link"
                target="_blank"
                >學習實錄<img :src="linkArrow" alt=""
              /></a>
            </div>
          </div>
        </template>
      </div>
      <div class="arrows text-end d-flex justify-content-end">
        <button class="flex-center scroll-btn scroll-left">
          <img :src="arrowLeft" alt="" />
        </button>
        <button class="flex-center scroll-btn scroll-right">
          <img :src="arrowRight" alt="" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import 'overlayscrollbars/css/OverlayScrollbars.min.css';
import OverlayScrollbars from 'overlayscrollbars/js/OverlayScrollbars.min';

import linkArrow from '@/assets/img/link_arrow.png';
import arrowLeft from '@/assets/img/arrow-left.svg';
import arrowRight from '@/assets/img/arrow-right.svg';
import y1 from '@/assets/img/y1.png';
import y2 from '@/assets/img/y2.png';
import y3 from '@/assets/img/y3.png';
import y4 from '@/assets/img/y4.png';
import y5 from '@/assets/img/y5.png';

// api
import { getRecordList } from '@/api/record';

export default {
  name: 'Records',
  components: {

  },
  data() {
    return {
      arrowLeft,
      arrowRight,
      linkArrow,
      loaded: false,
      img: [y1, y2, y3, y4, y5],
      records: [],
    };
  },
  // created() { },
  async mounted() {
    // const cxt = this;
    const settings = {
      className: 'os-theme-dark',
      sizeAutoCapable: true,
      paddingAbsolute: true,
      overflowBehavior: {
        x: 'scroll',
        y: 'hidden',
      },
      scrollbars: {
        clickScrolling: true,
        visibility: 'auto',
      },
      // callbacks: {
      //   onInitialized() {
      //     cxt.$store.commit('setLoadingState', { status: false });
      //   },
      // },
    };
    // this.$store.commit('setLoadingState', { status: true });
    const filter = { order: 'year desc' };
    await getRecordList({ filter }).then((response) => {
      this.records = response;
      // setTimeout(() => {
      // this.$store.commit('setLoadingState', { status: false });
      // }, 700);
      this.loaded = true;
    });
    const rScroll = OverlayScrollbars(document.querySelectorAll('.records-wrapper'), settings);
    document.querySelector('#records-mobile .scroll-left').addEventListener('click', () => rScroll.scroll({ x: '-= 300px' }));
    document.querySelector('#records-mobile .scroll-right').addEventListener('click', () => rScroll.scroll({ x: '+= 300px' }));
  },
};
</script>

<style lang="stylus" scoped>
.content-height
  height: 150vh;

.year-block
  width: 100%;
  height: 200px;
  padding: 20px;
  overflow: hidden;
  background-image: linear-gradient(
    rgba(95, 95, 95, 0) 33.79%,
    rgba(0, 0, 0, 0.5) 100%
  );

  &:hover
    background-color: rgba(244, 243, 238, 0.5);
    background-image: linear-gradient(
      rgba(188, 184, 177, 0.3),
      rgba(188, 184, 177, 0.3)
    ), linear-gradient(
      180deg,
      rgba(95, 95, 95, 0) 33.79%,
      rgba(0, 0, 0, 0.5) 100%
    );

    .year
      transition: all 0.3s linear;
      color: $monoc4;
      margin-top: 88px;

    .tags
      transition: all 0.3s linear;
      margin-top: 16px;

.year
  color: $monoc1;
  margin-top: 134px;

.tags
  margin-top: 32px;

.tag-link
  border: 2px solid $monoc4;
  color: $monoc4;
  border-radius: 100px;
  padding: 4px 4px 4px 10px;
  text-decoration: none;
  font-size: 1rem;
  line-height: 23px;
  margin-left: 1px;

  img
    width: 24px;
    margin-left: 8px;

  +.tag-link
    margin-left: 16px;

@media screen and (min-width: 992px) and (max-width: 1400px)
  .tag-link
    padding: 4px;

    img
      display: none;

.main-image
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 30vh;

#records-mobile
  position: relative;
  width: 100%;

.records-wrapper
  padding-bottom: 24px;
  white-space: nowrap;

.records-unit
  width: 360px;
  white-space: normal;

@media screen and (max-width: 575.7px)
  .records-unit
    width: 100%;
</style>

<style lang="stylus">
@media screen and (max-width: 991.5px)
  #record-carousel
    .carousel__pagination
      justify-content: flex-start;

    .carousel__prev
      left: initial;
      right: 20px !important;

    .carousel__next
      left: initial;
      right: 10px !important;
</style>
